import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
//import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { AlertaConfirmDialog } from '../alerta-confirm';

@Component({
  selector: 'app-me-perfil-foto',
  templateUrl: './me-perfil-foto.component.html',
  styleUrls: ['./me-perfil-foto.component.css']
})
export class MePerfilFotoComponent implements OnInit {
  @ViewChild("uploader") meuUploader: ElementRef;
  @ViewChild("savePic") savePic: ElementRef;
  hideCL: boolean = false;
  nomeArquivo: any = '';
  imageChangedEvent: any = '';
  croppedImage: any = '';
  arrFotos: any[] = [];
  urlFoto: any = '';
  urlFotoSec: any = '';
  fotoPerfil: any = '';
  espacoVazio: any[] = [];
  showTools: boolean = false;
  insFotoSec: boolean = false;
  canvasRotation: any = 0;
  rotation: any = 0;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    //this.hideCL = true;
    this.buscarInfoUser(this.tmaService.hcNomeUsuario);
    this.tmaService.eventoFS(true);
  }

  ngAfterViewInit() {

  }
  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }




  buscarInfoUser(qUsuario: any): void {
    //server side
    this.hideCL = false;
    var dadosIn = 'nomeusuario=' + qUsuario + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.listarPerfilP(dadosIn)
      .subscribe((qRes) => {
        console.log(qRes);
        this.hideCL = true;
        if (qRes['res'] == 'done') {
          this.fotoPerfil = qRes['dadosUsuario'].fotoPerfil;
          this.arrFotos = qRes['userFotos'];
          console.log(this.arrFotos);

          var totalF = qRes['userFotos'].length;
          // if(this.fotoPerfil != ''){
          //     totalF += 1;
          // }
          var slotRes = 5 - totalF;
          this.espacoVazio = Array(slotRes).fill(0);
          //this.urlFoto =  "https://apptamas.melhorpedida.com/fotosusuarios/";
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
          this.urlFotoSec = this.tmaService.urlRepositorioS3 + "/users-sec-picture/";
          // this.cfgScroll(totalF);
        }
      })
  }



  rotacionarImg() :void{
    console.log("girando");
    this.canvasRotation--;
    //alguns celulares tem um certo delay pra rotacionar, então fazemos esse fake load
    this.hideCL = false;
    setTimeout(() => {
      this.hideCL = true;
    }, 1500);
  }

  trocaImg() :void{
    this.croppedImage = '';
    this.meuUploader.nativeElement.value = '';
    //console.log("just clear");
    //this.showTools = false;
    this.meuUploader.nativeElement.click();

  }
  
  addNovaFoto(isPerfil: boolean): void {
    console.log("foto de perfil " + isPerfil);
    if (isPerfil) {
      //this.showTools = true;
      this.insFotoSec = false;
      this.meuUploader.nativeElement.value = '';
      this.meuUploader.nativeElement.click();
    }
    else {
      //this.showTools = true;
      this.insFotoSec = true;
      this.meuUploader.nativeElement.value = '';
      this.meuUploader.nativeElement.click();
    }
  }

  excluirFoto(isPerfil: boolean, nomeFoto: any): void {
    if (isPerfil) {
      const avisoExcFotoP = this.dialog.open(AlertaConfirmDialog, {
        // width: '250px',
        disableClose: true,
        data: { iconAlerta: 'warning', tituloAlerta: "Aviso", textoAlerta: "Desja alterar a foto de perfil?", textoCancel: "Não", textoConfirm: "Sim" }
      });
      avisoExcFotoP.afterClosed().subscribe((result) => {
        console.log(result);
        if (result == true) {
          //como é perfil apenas alteramos, não pode ficar sem
          this.fotoPerfil = '';
          this.addNovaFoto(true);
        }
      });
    }
    else {
      const avisoExcFoto = this.dialog.open(AlertaConfirmDialog, {
        // width: '250px',
        disableClose: true,
        data: { iconAlerta: 'warning', tituloAlerta: "Aviso", textoAlerta: "Desja excluir esta foto?", textoCancel: "Não", textoConfirm: "Sim" }
      });
      avisoExcFoto.afterClosed().subscribe((result) => {
        console.log(result);
        if (result == true) {
          //chamada no servidor
          this.hideCL = false;
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            mfoto: nomeFoto
          };
          this.tmaService.deletarFotoSec(customParams).subscribe((qRes) => {
            this.hideCL = true;
            console.log(qRes);
            if (qRes['res'] == 'done') {
              const opDone = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Foto excluída com sucesso!", iconAlerta: 'done_all' }
              })
              this.buscarInfoUser(this.tmaService.hcNomeUsuario);
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
              })
            }
          },
            (error) => {
              this.hideCL = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
        }
      });
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    var formatoArq = this.imageChangedEvent.target.files[0].type;

    console.log(event);

    if(formatoArq.indexOf('video') != -1){
      this.croppedImage = '';
      this.meuUploader.nativeElement.value = '';
      this.showTools = false;
      const notVideoAllowed = this.dialog.open(AlertaSimplesDialog, {
        width: '300px',
        data: {  iconAlerta: 'warning', tituloAlerta: "Aviso", textoAlerta: "Formato incorreto.<br>Apenas fotos são permitidas.", textoConfirm: "Ok" }
      });
      return;
    }
    else{
      if (this.imageChangedEvent.target.files.length == 0) {
        this.croppedImage = '';
        console.log("just clear");
        this.showTools = false;
      }
      else {
        console.log("teste");
        console.log(this.imageChangedEvent.target.files[0].type);
        //alert(this.imageChangedEvent.target.files[0].type);
        this.showTools = true;
        this.hideCL = false;
        // setTimeout(() => {
        //   this.savePic.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // }, 200);
      }
    }


  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    console.log(this.croppedImage);
  }
  imageLoaded() {
    console.log("foiiiiiiiii");
    this.savePic.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // show cropper
  }
  cropperReady() {
    // cropper ready
    this.hideCL = true;
  }
  loadImageFailed() {
    // show message
    console.log("failed");
    this.hideCL = true;
  }

  voltar(): void {
    //this._location.back();
    this.router.navigate(['/' + this.tmaService.hcNomeUsuario ]);
    // if (this.tmaService.gUrlAnterior == 'validar') {
    //   const notEmptyallowerdd = this.dialog.open(AlertaSimplesDialog, {
    //     width: '300px',
    //     data: { tituloAlerta: "Aviso", textoAlerta: "Você deve informar o estado e a cidade para prosseguir com seu cadastro", textoConfirm: "Ok" }
    //   });
    // }
    // else {
    //   this.router.navigate(['/' + this.tmaService.hcNomeUsuario ]);
    // }
  }

  uploadFile($event) {
    console.log($event.target.files[0]); // outputs the first file
    this.nomeArquivo = $event.target.files[0].name;
  }

  salvar(): void {
    //verificar url anterior
    if (this.croppedImage == '') {
      const notEmptyallowerdd = this.dialog.open(AlertaSimplesDialog, {
        width: '300px',
        data: { tituloAlerta: "Aviso", textoAlerta: "Você deve enviar uma foto para continuar", textoConfirm: "Ok" }
      });
      return;
    }
    else {
      //enviar para servidor 
      this.hideCL = false;
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        fotoBase: encodeURI(this.croppedImage)
      };
      //var meusDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&fotobase=' + this.croppedImage;
      if (!this.insFotoSec) {
        this.tmaService.addFotoPerfil(customParams)
          .subscribe((qDados) => {
            console.log(qDados);
            this.hideCL = true;
            this.croppedImage = '';
            this.showTools = false;
            this.buscarInfoUser(this.tmaService.hcNomeUsuario);
            //após salvar, faz o redirect
            // if (this.tmaService.gUrlAnterior == 'validar') {
            //   //continuar cadastro
            //   this.router.navigate(['/me/foto']);
            // }
            // else {
            //   //volta ao perfil
            //   this.router.navigate(['/me/perfil']);
            // }
          })
      }
      else {
        this.tmaService.addFotoSec(customParams)
          .subscribe((qDados) => {
            console.log(qDados);
            this.hideCL = true;
            this.croppedImage = '';
            this.showTools = false;
            this.buscarInfoUser(this.tmaService.hcNomeUsuario);
            //após salvar, faz o redirect
            //volta ao perfil
            //this.router.navigate(['/me/perfil']);
          })
      }
    }
  }

}
